import { NgModule, Optional, SkipSelf, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthAdapterService } from './oauth-adapter.service';
import { environment } from '../../../environments/env';
import {
  AuthExtensionModule,
  AuthExtensionModuleConfig,
  ObfuscatedStorage,
} from '@rco/angular-auth-extensions';
import { AuthConfig, OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';
import { oAuthAdapterInitializerFactory } from './oauth-adapter-initializer.factory';

// const moduleConfig: AuthExtensionModuleConfig = {
//   protectedUrls: [environment.serviceDomain]
// }

const apiUrl = `${environment.apiUrl}`;
const moduleConfig: AuthExtensionModuleConfig = {
  protectedUrls: [apiUrl],
};

export function storageFactory(): any {
  return new ObfuscatedStorage(sessionStorage);
}

// const authConfig: AuthConfig = {
//   issuer: environment.discoveryUrl,
//   clientId: environment.clientId,
//   responseType: 'code',
//   redirectUri: `${window.location.origin}/login/token`,
//   redirectUriAsPostLogoutRedirectUriFallback: false,
//   scope: environment.scope,
//   showDebugInformation: true,
//   strictDiscoveryDocumentValidation: false,
// };

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    OAuthModule.forRoot(),
    AuthExtensionModule.forRoot({
      authService: OauthAdapterService,
      moduleConfig: moduleConfig,
    }),
  ],
  exports: [OAuthModule, AuthExtensionModule],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (oAuthAdapterInitializerFactory)(inject(OauthAdapterService));
        return initializerFn();
      }),
    { provide: OAuthStorage, useFactory: storageFactory },
    // { provide: AuthConfig, useValue: authConfig },
  ],
})
export class OauthAdapterModule {
  constructor(@Optional() @SkipSelf() parentModule: OauthAdapterModule) {
    if (parentModule) {
      throw new Error(
        'OauthAdapterModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
